import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const today    = dayjs();
const dateFrom = today.subtract(30, 'day').format('YYYY-MM-DD');
const dateTo   = today.format('YYYY-MM-DD');

const initialState = {
	tables:  [],
	sides:   [],
	vendors: [],

	selectedTable:    'VTK S12 4G DATA',
	selectedSides:    [],
	selectedVendors:  [],
	selectedType:     'both',
	preset:           '31d',
	dateFrom,
	dateTo,

	rows:        [],
	displayFrom: null,
	displayTo:   null,
	loading: false,
	error:   null,

	selectedDayIdx:    null,
	selectedDrillType: 'Site',

	volumeThreshold: 80,  // % of the median below which it is considered a gap
	medianWindow:    30,  // number of days used to compute the reference median

	// highlight modes
	highlightGapDays:  false,   // highlight dias com gaps no heatmap
	vendorFilter:      null,    // filtra heatmap por vendor específico
};

const dataIntegritySlice = createSlice({
	name: 'dataIntegrity',
	initialState,
	reducers: {
		setFilters(state, { payload }) {
			state.tables  = payload.tables  ?? [];
			state.sides   = payload.sides   ?? [];
			state.vendors = payload.vendors ?? [];
			if (!state.selectedTable && payload.tables?.length)
				state.selectedTable = payload.tables.includes('VTK S12 4G DATA')
					? 'VTK S12 4G DATA'
					: payload.tables[0];
		},
		setSidesAndVendors(state, { payload }) {
			state.sides   = payload.sides   ?? [];
			state.vendors = payload.vendors ?? [];
		},
		setData(state, { payload }) {
			state.rows        = Array.isArray(payload) ? payload : (payload.rows ?? []);
			state.displayFrom = payload.displayFrom ?? null;
			state.displayTo   = payload.displayTo   ?? null;
			state.error            = null;
			state.selectedDayIdx   = null;
			state.selectedDrillType = 'Site';
			state.highlightGapDays  = false;
			state.vendorFilter      = null;
		},
		setLoading(state, { payload }) { state.loading = payload; },
		setError(state,   { payload }) { state.error   = payload; },

		setSelectedTable(state,   { payload }) { state.selectedTable   = payload; },
		setSelectedSides(state,   { payload }) { state.selectedSides   = payload; },
		setSelectedVendors(state, { payload }) { state.selectedVendors = payload; },
		setSelectedType(state,    { payload }) { state.selectedType    = payload; },
		setPreset(state, { payload }) {
			state.preset = payload;
			const t = dayjs();
			if (payload === '7d')  { state.dateFrom = t.subtract(6,  'day').format('YYYY-MM-DD'); state.dateTo = t.format('YYYY-MM-DD'); }
			if (payload === '31d') { state.dateFrom = t.subtract(30, 'day').format('YYYY-MM-DD'); state.dateTo = t.format('YYYY-MM-DD'); }
			if (payload === '90d') { state.dateFrom = t.subtract(89, 'day').format('YYYY-MM-DD'); state.dateTo = t.format('YYYY-MM-DD'); }
		},
		setCustomRange(state, { payload }) {
			state.preset   = 'custom';
			state.dateFrom = payload.dateFrom;
			state.dateTo   = payload.dateTo;
		},
		setSelectedDayIdx(state,    { payload }) { state.selectedDayIdx    = payload; },
		setSelectedDrillType(state, { payload }) { state.selectedDrillType = payload; },
		setVolumeThreshold(state,   { payload }) { state.volumeThreshold   = payload; },
		setMedianWindow(state,     { payload }) { state.medianWindow     = payload; },

		toggleHighlightGapDays(state) {
			state.highlightGapDays = !state.highlightGapDays;
			state.vendorFilter     = null;  // reset vendor filter quando muda o modo
		},
		setVendorFilter(state, { payload }) {
			state.vendorFilter    = payload;
			state.highlightGapDays = false; // reset gap highlight quando filtra vendor
		},
	},
});

export const {
	setFilters, setSidesAndVendors, setData, setLoading, setError,
	setSelectedTable, setSelectedSides, setSelectedVendors,
	setSelectedType, setPreset, setCustomRange,
	setSelectedDayIdx, setSelectedDrillType,
	setVolumeThreshold, setMedianWindow,
	toggleHighlightGapDays, setVendorFilter,
} = dataIntegritySlice.actions;

export const selectTables            = s => s.dataIntegrity.tables;
export const selectSides             = s => s.dataIntegrity.sides;
export const selectVendors           = s => s.dataIntegrity.vendors;
export const selectSelectedTable     = s => s.dataIntegrity.selectedTable;
export const selectSelectedSides     = s => s.dataIntegrity.selectedSides;
export const selectSelectedVendors   = s => s.dataIntegrity.selectedVendors;
export const selectSelectedType      = s => s.dataIntegrity.selectedType;
export const selectPreset            = s => s.dataIntegrity.preset;
export const selectDateFrom          = s => s.dataIntegrity.dateFrom;
export const selectDateTo            = s => s.dataIntegrity.dateTo;
export const selectRows              = s => s.dataIntegrity.rows;
export const selectDisplayFrom       = s => s.dataIntegrity.displayFrom;
export const selectDisplayTo         = s => s.dataIntegrity.displayTo;
export const selectLoading           = s => s.dataIntegrity.loading;
export const selectError             = s => s.dataIntegrity.error;
export const selectSelectedDayIdx    = s => s.dataIntegrity.selectedDayIdx;
export const selectSelectedDrillType = s => s.dataIntegrity.selectedDrillType;
export const selectHighlightGapDays  = s => s.dataIntegrity.highlightGapDays;
export const selectVendorFilter      = s => s.dataIntegrity.vendorFilter;
export const selectVolumeThreshold   = s => s.dataIntegrity.volumeThreshold;
export const selectMedianWindow      = s => s.dataIntegrity.medianWindow;

export default dataIntegritySlice.reducer;